export default __webpack_public_path__ + "static/media/manningBooth.e28f93cf.svg";